import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WeddingNavbar from './components/WeddingNavbar';
import WeddingFooter from './components/WeddingFooter';
import WeddingHome from './pages/WeddingHome';
import OurStory from './pages/OurStory';
import Gallery from './pages/Gallery';
import LoveNotes from './pages/LoveNotes';
import NoorPage from './pages/NoorPage';
import PriyaPage from './pages/PriyaPage';
import InteractiveGames from './pages/InteractiveGames';
import Quiz from './pages/Quiz';

const App: React.FC = () => {
  return (
    <Router>
      <div className="min-h-screen gradient-bg">
        <WeddingNavbar />
                <Routes>
                  <Route path="/" element={<WeddingHome />} />
                  <Route path="/our-story" element={<OurStory />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/love-notes" element={<LoveNotes />} />
                  <Route path="/noor" element={<NoorPage />} />
                  <Route path="/priya" element={<PriyaPage />} />
                  <Route path="/games" element={<InteractiveGames />} />
                  <Route path="/quiz" element={<Quiz />} />
                </Routes>
        <WeddingFooter />
      </div>
    </Router>
  );
};

export default App;
